import { render, staticRenderFns } from "./ViewCompany.vue?vue&type=template&id=cc524748&"
import script from "./ViewCompany.vue?vue&type=script&lang=js&"
export * from "./ViewCompany.vue?vue&type=script&lang=js&"
import style0 from "./ViewCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports